/**
 * Written by Raz 25/12/2016
 * An Angular application to contact the API and load the articles, while also placing the adds slots in the correct order.
 *
 **/
var loadAjaxArticles = angular.module('loadAjaxArticles',
    ['infinite-scroll', 'ngSanitize']);

// a filter for adding HTML when we add the add slots
loadAjaxArticles.filter('sanitize', [
  '$sce', function($sce) {
    return function(htmlCode) {
      return $sce.trustAsHtml(htmlCode);
    };
  }]);

loadAjaxArticles.controller('loadArticlesController', [
  '$scope', '$log', '$http', '$window', '$q', function(
      $scope,
      $log,
      $http,
      $window,
      $q) {

    $scope.spotlight = false;
    $scope.editorPicks = true;

// custom init function, receives the starting parameters from the server through the dom.
    $scope.init = function(
        layout,
        locationID,
        articlesPerGenre,
        postsPerCategory,
        category,
        section,
        dfp_env,
        type,
        summaryNum,
        articleId,
        searchQuery,
        sponsoredLabel,
        categorySlug,
        is_json_api,
        no_ads,
        active_slots,
        kgID) {

      $scope.limitnum = 75;
      $scope.layout = layout;
      $scope.locationID = locationID;
      $scope.articlesPerGenre = articlesPerGenre;
      $scope.postsPerCategory = postsPerCategory;
      $scope.category = category;
      $scope.section = section;
      $scope.env = dfp_env;
      $scope.pageType = type;
      $scope.sponsoredLabel = sponsoredLabel;
      $scope.categorySlug = categorySlug;

      if (parseInt(no_ads)) {
        $scope.no_ads = '&na=1';
      } else {
        $scope.no_ads = '&na=0';
      }

      if (parseInt(is_json_api)) {
        $scope.is_json_api = '&japi=1';
      } else {
        $scope.is_json_api = '&japi=0';
      }

      if (kgID) {
        $scope.kgID = kgID;
      } else {
        $scope.kgID = false;
      }

      if ($scope.layout === 'location') {
        $scope.scrolled_articles = [];
        $scope.spotlight = false;
        $scope.editorPicks = [];
      }

      if (summaryNum === undefined) {
        $scope.summaryNum = 3;
      } else {
        $scope.summaryNum = summaryNum;
      }

      if (articleId === undefined) {
        $scope.articleId = 0;
        $scope.active_slots = false;
      } else {
        $scope.articleId = articleId;
        $scope.active_slots = active_slots;
      }

      if (searchQuery === undefined) {
        $scope.searchQuery = '';
      } else {
        $scope.searchQuery = searchQuery;
      }

      $scope.busy = false;
      $scope.showbtn = false;
      $scope.showloadingbtn = true;
      $scope.stopscrolling = false;
      $scope.showprogress = true;

      // if the layout is list, we need to bind scrolling to create the infinite scrolling effect.
      if ($scope.layout === 'list' || $scope.layout === 'searchList' ||
          $scope.layout === 'location') {
        angular.element($window).bind('scroll', function() {

          $scope.st = window.pageYOffset;
          if ($scope.st > $scope.lastScrollTop) {
            $scope.scrollDirection = 'down';
          } else {
            $scope.scrollDirection = 'up';
          }

          $scope.lastScrollTop = $scope.st;
          $scope.$apply();
          if ($scope.scrollDirection === 'up') {
            if ($scope.layout === 'location') {
              num = 1;
            } else {
              num = 2;
            }
            if ($scope.howmanytimes > num) {
              $scope.showprogress = false;
              if ($scope.url !== false) {
                $scope.stopscrolling = true;
                $scope.showbtn = true;
              }
            }
          }
        });

        if ($scope.layout === 'searchList') {
          $scope.url = TCTServer.api + 'v1/articles?s=' + $scope.searchQuery +
              '&offset=0&limit=' + $scope.articlesPerGenre;
          $scope.noResults = false;
          $scope.errorInApi = false;
          $scope.searchResults = false;
          $scope.totalArticles = false;
          $scope.offset = $scope.articlesPerGenre;
        } else if ($scope.pageType === 'News') {
          $scope.url = TCTServer.api + 'v1/articles/news?offset=0&limit=' +
              $scope.articlesPerGenre;
        } else if ($scope.pageType === 'Author') {
          $scope.url = TCTServer.api + 'v1/articles/authors/' +
              $scope.locationID + '?offset=0&limit=' + $scope.articlesPerGenre;

        } else if ($scope.pageType === '404') {
          $scope.url = TCTServer.api + 'v1/articles?offset=0&limit=' +
              $scope.articlesPerGenre;
          $scope.offset = $scope.articlesPerGenre;
        } else if ($scope.layout === 'location') {
          $scope.url = TCTServer.api +
              'v2/articles?queryType=location_page&limit=15&offset=0&kgID=' +
              $scope.kgID;
        }
        else {
          $scope.url = TCTServer.api + 'v1/articles/locations/' +
              $scope.locationID + '?data=true&queryType=topNav&category=' +
              $scope.category + '&offset=0&limit=' + $scope.articlesPerGenre;
        }
      } else if ($scope.layout === 'summary') {
        $scope.url = TCTServer.api + 'v1/articles/locations/' +
            $scope.locationID + '?data=true&postPerCategory=' +
            $scope.postsPerCategory + '&category=99999';
      } else if ($scope.layout === 'editorsPicks') {
        if ($scope.pageType === 'Vertical') {
          $scope.url = TCTServer.api +
              'v1/articles?queryType=spotlight&category=' +
              $scope.categorySlug + '&offset=0&limit=3';
        } else if ($scope.pageType === 'Genre') {
          $scope.url = TCTServer.api +
              'v1/articles?queryType=spotlight&category=' +
              $scope.categorySlug + '&offset=0&limit=3';
          $scope.editorPicksUrl = TCTServer.api +
              'v1/articles?queryType=editors_picks&category=' +
              $scope.categorySlug + '&offset=0&limit=3';
        } else if ($scope.pageType === 'Location') {
          $scope.url = TCTServer.api +
              'v1/articles?queryType=spotlight&wordPressLocationID=' +
              $scope.locationID;
          $scope.editorPicksUrl = TCTServer.api +
              'v1/articles?queryType=editors_picks&wordPressLocationID=' +
              $scope.locationID;
        } else if ($scope.pageType === 'Home') {
          $scope.url = TCTServer.api + 'v1/articles/1206975';

          $scope.url = TCTServer.api +
              'v1/articles?queryType=editors_picks&wordPressLocationID=' +
              $scope.locationID;
        }
      }

      // if we have an article id, we are in an article page and need to change the url.
      if ($scope.articleId > 0) {
        $scope.url = TCTServer.api +
            'v1/articles/related?wordPressLocationID=' + $scope.locationID +
            '&postID=' + $scope.articleId + '&userWordPressLocation=0';
        $scope.showbtn = true;
        $scope.showprogress = false;

        // setup A\B test
        $scope.testId = 930;
        $scope.shouldRunTest = !!TCT && !!TCT.Testing && !!$scope.testId;
      }

      $scope.items = [];
      $scope.tempitems = [];
      if ($scope.layout === 'summary') {
        $scope.summaryGenres = [];
      }

      $scope.howmanytimes = 0;
      $scope.st = 0;
      $scope.lastScrollTop = 0;
      $scope.scrollDirection = false;
      $scope.didWeGetAdSlots = false;
      $scope.adSlots = [];
      $scope.filledAdSlots = [];

      $scope.trackCTA = $window.trackCTA;

      $scope.noMoreLocation = false;
      $scope.noMore = false;

      if ($scope.shouldRunTest) {
        // call test and then run, no matter the result (variant is passed to API through the cookie)
        TCT.Testing.getTestData($scope.testId).
            then($scope.apiCall, $scope.apiCall);
      } else {
        // run immediately
        $scope.apiCall();
      }
    };

    // custom init method for recommended and trending
    $scope.trendingInit = function(
        popularNum, dfp_env, type, sponsoredLabel, campaignID, postID,
        is_json_api, no_ads) {
      $scope.showprogress = true;
      $scope.showloadingbtn = true;
      $scope.recommended = false;
      $scope.trending = false;
      $scope.limitnum = 75;
      $scope.popularNum = popularNum;

      $scope.campaignID = campaignID;
      $scope.postID = postID;

      $scope.env = dfp_env;
      $scope.pageType = type;
      $scope.urlPopular = TCTServer.api +
          'v1/articles/mostPopular?limit=4&postID=' + $scope.postID;
      $scope.sponsoredLabel = sponsoredLabel;
      $scope.trackCTA = $window.trackCTA;

      if ($scope.campaignID !== 'undefined' && $scope.campaignID > 0) {
        $scope.urlSponsored = TCTServer.api +
            'v1/articles?queryType=sponsored_articles&campaignID=' +
            $scope.campaignID + '&limit=20&offset=0&postID=' + $scope.postID;

      }

      if (parseInt(no_ads)) {
        $scope.no_ads = '&na=1';
      } else {
        $scope.no_ads = '&na=0';
      }

      if (parseInt(is_json_api)) {
        $scope.is_json_api = '&japi=1';
      } else {
        $scope.is_json_api = '&japi=0';
      }

      $scope.apiCallPopular();
    };

    // method to load more when the layout is list.
    // called when the user clicked on the "show more" button.
    $scope.loadMore = function() {
      $scope.showloadingbtn = true;
      $scope.stopscrolling = false;
      $scope.showbtn = false;
      $scope.showprogress = true;
      $scope.apiCall();
    };

    // main api call to fetch articles.
    $scope.apiCall = function(param) {
      if ($scope.url === false) return;

      $scope.showloadingbtn = true;

      if ($scope.layout === 'list' || $scope.layout === 'searchList' ||
          $scope.layout === 'location') {
        $scope.howmanytimes++;
        if ($scope.stopscrolling) return;
        if ($scope.busy) return;
        $scope.busy = true;
      }

      if (param && !!TCT && !!TCT.debug) {
        TCT.debug('API was called with param:', param);
      }

      if ($scope.section === 'related') {
        $scope.showbtn = false;
      }

      if ($scope.section === 'related' && $scope.active_slots) {
        var addActiveSlots = '&active_slots=' + $scope.active_slots;
      } else {
        var addActiveSlots = '';
      }

      var adSlotsUrl = TCTServer.theme + '/dfp/servlet.php?env=' + $scope.env +
          '&page_type=' + $scope.pageType + '&section=' + $scope.section +
          $scope.is_json_api + $scope.no_ads + addActiveSlots;

      var apiCalls = [];

      $scope.showprogress = true;
      $scope.tilescall = $http.get($scope.url,
          {headers: {'scrolled_article': $scope.scrolled_articles}},
          {cache: false, withCredentials: $scope.shouldRunTest});
      apiCalls.push($scope.tilescall);
      if ($scope.layout === 'editorsPicks' &&
          ($scope.pageType === 'Genre' || $scope.pageType === 'Location')) {
        $scope.editortilescall = $http.get($scope.editorPicksUrl, {
          cache: false,
          withCredentials: $scope.shouldRunTest,
        });
        apiCalls.push($scope.editortilescall);
      }

      if ($scope.didWeGetAdSlots === false) {
        $scope.adSlotsCall = $http.get(adSlotsUrl,
            {cache: false, withCredentials: false});
        apiCalls.push($scope.adSlotsCall);
      }

      $q.all(apiCalls).then(function(results) {

        if ($scope.layout === 'editorsPicks' &&
            ($scope.pageType === 'Genre' || $scope.pageType === 'Home')) {

          if (typeof results[0].data['articleResources'] === 'undefined') {
            $scope.spotlight = false;
            $scope.editorPicks = false;
            $scope.showprogress = false;
            return false;
          }

          if ($scope.pageType === 'Home') {
            var theData = results[0].data['articleResources'];
          } else {

            var theData = results[0].data['articleResources'].concat(
                results[1].data['articleResources']);
          }

          if ($scope.didWeGetAdSlots === false) {
            $scope.makeTiles(theData);
            if ($scope.layout === 'editorsPicks') {
              if (results[1].data)
                $scope.adSlots = results[1].data;

            } else {
              if (results[2].data)
                $scope.adSlots = results[2].data;
            }
            $scope.didWeGetAdSlots = true;
          } else {
            $scope.makeTiles(theData);
          }

        } else {

          theData = results[0].data;
          if (results[1]) {
            theAdslots = results[1].data;
          } else {
            theAdslots = false;
          }

          if ($scope.didWeGetAdSlots === false) {

            $scope.makeTiles(theData);
            $scope.adSlots = theAdslots;
            $scope.didWeGetAdSlots = true;
          } else {

            $scope.makeTiles(results[0].data);
            if ($scope.layout === 'searchList' && results[0].data['links'] &&
                results[0].data['links'].length > 0)
              $scope.offset = parseInt($scope.offset) +
                  parseInt($scope.articlesPerGenre);
          }

        }

        $scope.setAdSlots($scope.adSlots);

        $scope.items = $scope.tempitems;

      }, function(errors) {
        TCT.warn('something went wrong! ' + errors);
        $scope.showprogress = false;
        if ($scope.layout === 'searchList') {
          $scope.errorInApi = true;
        }
      });
    };

    // setting add slots according to articles we have in $scope.tempitems.
    $scope.setAdSlots = function(data) {
      angular.forEach(data, function(value, key) {
        key = key - 1;
        if (typeof $scope.tempitems[key] !== 'undefined') {
          if (typeof $scope.tempitems[key].adSlot === 'undefined')
            $scope.tempitems[key].adSlot = value;

        }
      });
    };

    // the method that goes over the data from the api and prepares the tiles by populating $scope.tempitems.
    $scope.makeTiles = function(data) {

      if (($scope.layout === 'editorsPicks' &&
              ($scope.pageType === 'Genre' || $scope.pageType === 'Location' ||
                  $scope.pageType === 'Home'))) {

        data['articleResources'] = data;
      }

      if ($scope.layout === 'location') {

        placeSponsoredLabel(data['data']);

        for (i = 0; i < data['data'].length; i++) {
          if (typeof (data['data'][i]['mainImage']['links'][0]) !==
              'undefined') {
            data['data'][i]['thumbnail'] = data['data'][i]['mainImage']['links'][0]['href'];
          } else {
            data['data'][i]['thumbnail'] = false;
          }

          if (typeof (data['data'][i]['name']) !== 'undefined') {
            data['data'][i]['title'] = data['data'][i]['name'];
          } else {
            data['data'][i]['title'] = false;
          }

          if (data['data'][i]['links'].length > 1) {
            if (typeof (data['data'][i]['links'][1]['href']) !== 'undefined')
              data['data'][i]['url'] = data['data'][i]['links'][1]['href'];
          } else {
            data['data'][i]['url'] = false;
          }

          if (typeof (data['data'][i]['category']) !== 'undefined') {
            data['data'][i]['articleCategory'] = data['data'][i]['category'];
          } else {
            data['data'][i]['articleCategory'] = false;
          }

          $scope.scrolled_articles.push(data['data'][i]['postID']);

          if (i === 0 && $scope.scrolled_articles.length < 15) {
            $scope.spotlight = data['data'][i];
          } else if (i > 0 && i < 3 && $scope.scrolled_articles.length < 15) {
            $scope.editorPicks.push(data['data'][i]);
          } else {
            $scope.tempitems.push(data['data'][i]);
          }
        }

      } else {
        placeSponsoredLabel(data['articleResources']);

        for (i = 0; i < data['articleResources'].length; i++) {
          $scope.tempitems.push(data['articleResources'][i]);
        }
      }

      if ($scope.layout === 'list' || $scope.layout === 'searchList' ||
          $scope.layout === 'location') {
        $scope.processListTiles(data);
      }

      if ($scope.layout === 'summary') {
        $scope.processSummaryTiles();
      }

      if ($scope.layout === 'editorsPicks') {
        $scope.processEditorTiles(data);
      }

      $scope.showprogress = false;
    };

    /**
     * Places the sponsored label on appropriate article objects in the given
     * array
     * @param articles array The array of article objects to scan
     */
    function placeSponsoredLabel(articles) {
      if (articles && articles.length) {
        angular.forEach(articles, function(value) {
          if (value && value.isSponsored === true) {
            value.articleCategory = $scope.sponsoredLabel + ' ⋅ ' +
                value.articleCategory;
          }
        });
      }
    }

    $scope.processEditorTiles = function(data) {
      if ($scope.layout === 'editorsPicks' && $scope.pageType === 'Home') {
        $scope.editorPicks = data['articleResources'];
        placeSponsoredLabel($scope.editorPicks);
      } else {
        if (data['articleResources'][0]) {
          $scope.spotlight = data['articleResources'][0];
        } else {
          $scope.spotlight = false;
        }
        if (data['articleResources'][1]) {
          $scope.editorPicks = [];
          $scope.editorPicks.push(data['articleResources'][1]);
        } else {
          $scope.editorPicks = false;
        }
        if (data['articleResources'][2]) {
          $scope.editorPicks.push(data['articleResources'][2]);
        }
      }
    };

    $scope.processListTiles = function(data) {
      if (data['links'].length > 0) {
        $scope.url = data['links'][0].href;
      } else {
        $scope.url = false;
        $scope.formerUrl = false;
        $scope.showprogress = false;
        $scope.showbtn = false;
        $scope.showloadingbtn = false;

        if ($scope.pageType === 'Location' && $scope.layout === 'list') {
          $scope.noMoreLocation = true;
        } else {
          $scope.noMore = true;
        }
      }

      $scope.busy = false;

      if ($scope.layout === 'searchList') {
        $scope.totalArticles = data['count'];

        if ($scope.totalArticles < $scope.articlesPerGenre) {
          $scope.offset = $scope.totalArticles;
        }

        if ($scope.totalArticles > 0) {
          $scope.searchResults = true;
        } else {
          $scope.noResults = true;
        }

        if (data['links'].length < 1) {
          $scope.offset = $scope.totalArticles;
        }
      }
    };

    $scope.processSummaryTiles = function() {
      $scope.summarySection = [];
      var usedGroupId = [];
      var i = 0;
      var n = $scope.summaryNum;

      placeSponsoredLabel($scope.tempitems);

      angular.forEach($scope.tempitems, function(value) {
        if (!usedGroupId.hasOwnProperty(value.groupID)) {

          usedGroupId[value.groupID] = value;

          var theArticles = $scope.tempitems.slice(i, n);
          var theData = {
            articleCategory: value.articleCategory,
            categorySlug: value.categorySlug,
            articles: theArticles,
          };

          $scope.summarySection.push(theData);
          i = i + $scope.summaryNum;
          n = n + $scope.summaryNum;
        }
      });
    };

    // api call to get the trending and recommended articles
    $scope.apiCallPopular = function() {

      if ($scope.urlSponsored) {
        $scope.tempitems = [];

        $http.get($scope.urlSponsored).success(function(data) {
          if (data['articleResources'].length > 0) {
            for (var i = 0; i < data['articleResources'].length; i++) {
              $scope.tempitems.push(data['articleResources'][i]);
            }

            placeSponsoredLabel($scope.tempitems);
            $scope.showprogress = false;
            $scope.sponsoredArticles = $scope.tempitems;
          } else {
            $scope.showprogress = true;
            $scope.tempitems = [];
            $scope.recommended = [];
            $scope.trending = [];
            $scope.getRecommanded();
          }
        });
      } else {
        $scope.tempitems = [];
        $scope.recommended = [];
        $scope.trending = [];
        $scope.getRecommanded();
      }
    };

    $scope.getRecommanded = function() {
      var totalTiles = $scope.popularNum * 2;

      $http.get($scope.urlPopular).success(function(data) {
        for (var i = 0; i < data['articleResources'].length; i++) {
          $scope.tempitems.push(data['articleResources'][i]);
        }

        // make sure we've placed sponsored label for relevant articles
        placeSponsoredLabel($scope.tempitems);

        $scope.recommendedTemp = $scope.tempitems.slice(0, $scope.popularNum);
        $scope.trendingTemp = $scope.tempitems.slice($scope.popularNum,
            totalTiles);

        var adSlotsUrlRec = TCTServer.theme + '/dfp/servlet.php?env=' +
            $scope.env + '&page_type=' + $scope.pageType +
            '&section=recommended' + $scope.is_json_api + $scope.no_ads;

        var adSlotsUrlTrend = TCTServer.theme + '/dfp/servlet.php?env=' +
            $scope.env + '&page_type=' + $scope.pageType + '&section=trending' +
            $scope.is_json_api + $scope.no_ads;

        var apiCalls = [];

        var adSlotRecCall = $http.get(adSlotsUrlRec, {cache: false});
        apiCalls.push(adSlotRecCall);

        var adSlotTrendCall = $http.get(adSlotsUrlTrend, {cache: false});
        apiCalls.push(adSlotTrendCall);

        $q.all(apiCalls).then(function(results) {
          var recResults = results[0].data;
          var trendResults = results[1].data;

          angular.forEach(recResults, function(value, key) {
            key = key - 1;
            if (typeof $scope.recommendedTemp[key] !== 'undefined') {
              if (typeof $scope.recommendedTemp[key].adSlot === 'undefined')
                $scope.recommendedTemp[key].adSlot = value;
            }
          });

          angular.forEach(trendResults, function(value, key) {
            key = key - 1;
            if (typeof $scope.trendingTemp[key] !== 'undefined') {
              if (typeof $scope.trendingTemp[key].adSlot === 'undefined')
                $scope.trendingTemp[key].adSlot = value;
            }
          });
        }, function(errors) {
          $log.log('something went wrong! ' + errors.data);
        });

        $scope.recommended = $scope.recommendedTemp;
        $scope.trending = $scope.trendingTemp;
        $scope.showprogress = false;
      }).error(function(errors) {
        $log.log('Something went wrong - ' + errors);
      });
    };

  }]);

// a limit filter for angular. recieves the VALUE you want to limit
//WORDWISE - true or false, determines if the text will be cut mid-word of after a word
// MAX - number of maximum characters for your value.
// TAIL - an addition you may want to add to the cut value (could be "read more" or something similar, default is ...)
angular.module('loadAjaxArticles').filter('cut', function() {
  return function(value, wordWise, max, tail) {
    if (!value) return '';

    max = parseInt(max, 10);
    if (!max) return value;
    if (value.length <= max) return value;

    value = value.substr(0, max);

    if (wordWise) {
      var lastSpace = value.lastIndexOf(' ');

      if (lastSpace !== -1) {
        //Also remove . and , so its gives a cleaner result.
        if (value.charAt(lastSpace - 1) === '.' ||
            value.charAt(lastSpace - 1) === ',') {
          lastSpace = lastSpace - 1;
        }
        value = value.substr(0, lastSpace);
      }
    }

    return value + (tail || ' …');
  };
});

// bootstrap all relevant elements on page
var apps = document.getElementsByClassName('tct-ajax-tiles');
for (var i = 0; i < apps.length; i++) {
  angular.bootstrap(apps[i], ['loadAjaxArticles']);
}
